"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdatePlaceDTO = exports.UpgradeLaunchRequestDTO = exports.UpgradeCostRequestDTO = exports.ConquerUsingFoursquareId = exports.FindNearbyDTO = exports.ExploreSquareDTO = exports.FindNearestAvailableDTO = exports.ExploreDTO = exports.SearchPlaceDTO = exports.GetPlaceByUserDTO = exports.GetPlacesByFoursquareDTO = exports.GetPlaceByFoursquareDTO = exports.GetPlaceDTO = exports.PlaceLightListDTO = exports.PlaceListDTO = exports.PlaceDTO = exports.PlaceLightDTO = exports.PlaceTypeDTO = exports.PlaceDisplayFilters = exports.PlaceTypes = exports.PlaceAttackStatus = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const GeoIp_1 = require("./GeoIp");
const Map_1 = require("./Map");
const Rank_1 = require("./Rank");
const Resources_1 = require("./Resources");
var PlaceAttackStatus;
(function (PlaceAttackStatus) {
    PlaceAttackStatus["Attackable"] = "Attackable";
    PlaceAttackStatus["PlaceTooFar"] = "PlaceTooFar";
    PlaceAttackStatus["AlreadyOwned"] = "AlreadyOwned";
    PlaceAttackStatus["BelongsToAlly"] = "BelongsToAlly";
    PlaceAttackStatus["NotEnoughResources"] = "NotEnoughResources";
    PlaceAttackStatus["AttackInCooldown"] = "AttackInCooldown";
})(PlaceAttackStatus = exports.PlaceAttackStatus || (exports.PlaceAttackStatus = {}));
var PlaceTypes;
(function (PlaceTypes) {
    PlaceTypes["Airport"] = "Airport";
    PlaceTypes["Animals"] = "Animals";
    PlaceTypes["ArtsEntertainment"] = "ArtsEntertainment";
    PlaceTypes["Bar"] = "Bar";
    PlaceTypes["Castle"] = "Castle";
    PlaceTypes["Cemetery"] = "Cemetery";
    PlaceTypes["Church"] = "Church";
    PlaceTypes["Education"] = "Education";
    PlaceTypes["Factory"] = "Factory";
    PlaceTypes["Farm"] = "Farm";
    PlaceTypes["FastFood"] = "FastFood";
    PlaceTypes["FoodShop"] = "FoodShop";
    PlaceTypes["Garage"] = "Garage";
    PlaceTypes["Harbor"] = "Harbor";
    PlaceTypes["HardwareShop"] = "HardwareShop";
    PlaceTypes["Hotel"] = "Hotel";
    PlaceTypes["Medical"] = "Medical";
    PlaceTypes["Military"] = "Military";
    PlaceTypes["Nightlife"] = "Nightlife";
    PlaceTypes["Outdoors"] = "Outdoors";
    PlaceTypes["Police"] = "Police";
    PlaceTypes["Professional"] = "Professional";
    PlaceTypes["Restaurant"] = "Restaurant";
    PlaceTypes["ShopServices"] = "ShopServices";
    PlaceTypes["Stadium"] = "Stadium";
    PlaceTypes["Subway"] = "Subway";
    PlaceTypes["Train"] = "Train";
    PlaceTypes["TravelTransport"] = "TravelTransport";
    PlaceTypes["Misc"] = "Misc";
})(PlaceTypes = exports.PlaceTypes || (exports.PlaceTypes = {}));
var PlaceDisplayFilters;
(function (PlaceDisplayFilters) {
    PlaceDisplayFilters[PlaceDisplayFilters["None"] = 0] = "None";
    PlaceDisplayFilters[PlaceDisplayFilters["Zombies"] = 1] = "Zombies";
    PlaceDisplayFilters[PlaceDisplayFilters["Players"] = 2] = "Players";
    PlaceDisplayFilters[PlaceDisplayFilters["Bandits"] = 4] = "Bandits";
    PlaceDisplayFilters[PlaceDisplayFilters["EnergyI"] = 8] = "EnergyI";
    PlaceDisplayFilters[PlaceDisplayFilters["EnergyII"] = 16] = "EnergyII";
    PlaceDisplayFilters[PlaceDisplayFilters["EnergyIII"] = 32] = "EnergyIII";
})(PlaceDisplayFilters = exports.PlaceDisplayFilters || (exports.PlaceDisplayFilters = {}));
let PlaceTypeDTO = (() => {
    class PlaceTypeDTO {
    }
    __decorate([
        class_validator_1.IsEnum(PlaceTypes),
        __metadata("design:type", String)
    ], PlaceTypeDTO.prototype, "type", void 0);
    __decorate([
        class_validator_1.IsEnum(Resources_1.ResourceTypes),
        __metadata("design:type", String)
    ], PlaceTypeDTO.prototype, "productionType", void 0);
    return PlaceTypeDTO;
})();
exports.PlaceTypeDTO = PlaceTypeDTO;
let PlaceLightDTO = (() => {
    class PlaceLightDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], PlaceLightDTO.prototype, "id", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Number)
    ], PlaceLightDTO.prototype, "osmId", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], PlaceLightDTO.prototype, "ownerUserId", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], PlaceLightDTO.prototype, "isOwnerBandit", void 0);
    __decorate([
        class_validator_1.IsDate(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Date)
    ], PlaceLightDTO.prototype, "captureDate", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => PlaceTypeDTO),
        __metadata("design:type", PlaceTypeDTO)
    ], PlaceLightDTO.prototype, "type", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], PlaceLightDTO.prototype, "name", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], PlaceLightDTO.prototype, "address", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], PlaceLightDTO.prototype, "postalCode", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], PlaceLightDTO.prototype, "city", void 0);
    __decorate([
        class_validator_1.IsString(),
        class_validator_1.IsOptional(),
        __metadata("design:type", String)
    ], PlaceLightDTO.prototype, "country", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PlaceLightDTO.prototype, "level", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PlaceLightDTO.prototype, "maxLevel", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => Map_1.MapDTO),
        __metadata("design:type", Map_1.MapDTO)
    ], PlaceLightDTO.prototype, "map", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PlaceLightDTO.prototype, "longitude", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PlaceLightDTO.prototype, "latitude", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PlaceLightDTO.prototype, "healthPoints", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PlaceLightDTO.prototype, "maxHealthPoints", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PlaceLightDTO.prototype, "tiers", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PlaceLightDTO.prototype, "productionBonus", void 0);
    return PlaceLightDTO;
})();
exports.PlaceLightDTO = PlaceLightDTO;
let PlaceDTO = (() => {
    class PlaceDTO extends PlaceLightDTO {
    }
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => Resources_1.ResourcesDTO),
        class_validator_1.IsOptional(),
        __metadata("design:type", Resources_1.ResourcesDTO)
    ], PlaceDTO.prototype, "upgradeCost", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => Resources_1.ResourcesDTO),
        class_validator_1.IsOptional(),
        __metadata("design:type", Resources_1.ResourcesDTO)
    ], PlaceDTO.prototype, "repairCost", void 0);
    __decorate([
        class_validator_1.IsDate(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Date)
    ], PlaceDTO.prototype, "repairAvailableTime", void 0);
    __decorate([
        class_validator_1.IsDate(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Date)
    ], PlaceDTO.prototype, "upgradeAvailableTime", void 0);
    __decorate([
        class_validator_1.IsDate(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Date)
    ], PlaceDTO.prototype, "chestAvailableTime", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PlaceDTO.prototype, "upgradeProductionBonus", void 0);
    __decorate([
        class_validator_1.IsArray(),
        class_transformer_1.Type(() => Rank_1.PlaceRankDTO),
        class_validator_1.ValidateNested(),
        __metadata("design:type", Array)
    ], PlaceDTO.prototype, "ranking", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], PlaceDTO.prototype, "attackGasCost", void 0);
    __decorate([
        class_validator_1.IsDate(),
        class_validator_1.IsOptional(),
        __metadata("design:type", Date)
    ], PlaceDTO.prototype, "attackAvailableTime", void 0);
    __decorate([
        class_validator_1.IsEnum(PlaceAttackStatus),
        __metadata("design:type", String)
    ], PlaceDTO.prototype, "attackStatus", void 0);
    return PlaceDTO;
})();
exports.PlaceDTO = PlaceDTO;
class PlaceListDTO {
}
exports.PlaceListDTO = PlaceListDTO;
class PlaceLightListDTO {
}
exports.PlaceLightListDTO = PlaceLightListDTO;
let GetPlaceDTO = (() => {
    class GetPlaceDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetPlaceDTO.prototype, "id", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], GetPlaceDTO.prototype, "playerCoordinates", void 0);
    return GetPlaceDTO;
})();
exports.GetPlaceDTO = GetPlaceDTO;
let GetPlaceByFoursquareDTO = (() => {
    class GetPlaceByFoursquareDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], GetPlaceByFoursquareDTO.prototype, "foursquareId", void 0);
    return GetPlaceByFoursquareDTO;
})();
exports.GetPlaceByFoursquareDTO = GetPlaceByFoursquareDTO;
let GetPlacesByFoursquareDTO = (() => {
    class GetPlacesByFoursquareDTO {
    }
    __decorate([
        class_validator_1.IsArray(),
        class_validator_1.IsString({ each: true }),
        __metadata("design:type", Array)
    ], GetPlacesByFoursquareDTO.prototype, "foursquareIds", void 0);
    return GetPlacesByFoursquareDTO;
})();
exports.GetPlacesByFoursquareDTO = GetPlacesByFoursquareDTO;
let GetPlaceByUserDTO = (() => {
    class GetPlaceByUserDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], GetPlaceByUserDTO.prototype, "userId", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], GetPlaceByUserDTO.prototype, "playerCoordinates", void 0);
    return GetPlaceByUserDTO;
})();
exports.GetPlaceByUserDTO = GetPlaceByUserDTO;
let SearchPlaceDTO = (() => {
    class SearchPlaceDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], SearchPlaceDTO.prototype, "query", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], SearchPlaceDTO.prototype, "mapCoordinates", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], SearchPlaceDTO.prototype, "playerCoordinates", void 0);
    return SearchPlaceDTO;
})();
exports.SearchPlaceDTO = SearchPlaceDTO;
let ExploreDTO = (() => {
    class ExploreDTO {
    }
    __decorate([
        class_validator_1.IsNumber(),
        class_validator_1.Max(1000),
        __metadata("design:type", Number)
    ], ExploreDTO.prototype, "radius", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], ExploreDTO.prototype, "mapCoordinates", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], ExploreDTO.prototype, "playerCoordinates", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], ExploreDTO.prototype, "filters", void 0);
    return ExploreDTO;
})();
exports.ExploreDTO = ExploreDTO;
let FindNearestAvailableDTO = (() => {
    class FindNearestAvailableDTO {
    }
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], FindNearestAvailableDTO.prototype, "playerCoordinates", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], FindNearestAvailableDTO.prototype, "filters", void 0);
    __decorate([
        class_validator_1.IsArray(),
        __metadata("design:type", Array)
    ], FindNearestAvailableDTO.prototype, "availableTypes", void 0);
    return FindNearestAvailableDTO;
})();
exports.FindNearestAvailableDTO = FindNearestAvailableDTO;
let ExploreSquareDTO = (() => {
    class ExploreSquareDTO {
    }
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], ExploreSquareDTO.prototype, "centerCoordinates", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], ExploreSquareDTO.prototype, "topLeftCoordinates", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], ExploreSquareDTO.prototype, "bottomRightCoordinates", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], ExploreSquareDTO.prototype, "playerCoordinates", void 0);
    return ExploreSquareDTO;
})();
exports.ExploreSquareDTO = ExploreSquareDTO;
let FindNearbyDTO = (() => {
    class FindNearbyDTO {
    }
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], FindNearbyDTO.prototype, "userId", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], FindNearbyDTO.prototype, "mapCoordinates", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], FindNearbyDTO.prototype, "playerCoordinates", void 0);
    return FindNearbyDTO;
})();
exports.FindNearbyDTO = FindNearbyDTO;
class ConquerUsingFoursquareId {
}
exports.ConquerUsingFoursquareId = ConquerUsingFoursquareId;
class UpgradeCostRequestDTO {
}
exports.UpgradeCostRequestDTO = UpgradeCostRequestDTO;
let UpgradeLaunchRequestDTO = (() => {
    class UpgradeLaunchRequestDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], UpgradeLaunchRequestDTO.prototype, "placeId", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], UpgradeLaunchRequestDTO.prototype, "playerCoordinates", void 0);
    __decorate([
        class_validator_1.IsBoolean(),
        __metadata("design:type", Boolean)
    ], UpgradeLaunchRequestDTO.prototype, "immediate", void 0);
    return UpgradeLaunchRequestDTO;
})();
exports.UpgradeLaunchRequestDTO = UpgradeLaunchRequestDTO;
let UpdatePlaceDTO = (() => {
    class UpdatePlaceDTO {
    }
    __decorate([
        class_validator_1.IsString(),
        __metadata("design:type", String)
    ], UpdatePlaceDTO.prototype, "placeId", void 0);
    __decorate([
        class_validator_1.IsUUID(),
        __metadata("design:type", String)
    ], UpdatePlaceDTO.prototype, "ownerId", void 0);
    __decorate([
        class_validator_1.IsNumber(),
        __metadata("design:type", Number)
    ], UpdatePlaceDTO.prototype, "level", void 0);
    __decorate([
        class_validator_1.ValidateNested(),
        class_transformer_1.Type(() => GeoIp_1.Coordinates),
        __metadata("design:type", GeoIp_1.Coordinates)
    ], UpdatePlaceDTO.prototype, "playerCoordinates", void 0);
    return UpdatePlaceDTO;
})();
exports.UpdatePlaceDTO = UpdatePlaceDTO;
//# sourceMappingURL=Place.js.map